"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importDefault(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var inertia_react_2 = require("@inertiajs/inertia-react");
function Homepage(_a) {
    var canLogin = _a.canLogin, canRegister = _a.canRegister;
    var route = (0, useRoute_1.default)();
    var page = (0, useTypedPage_1.default)();
    return (react_1.default.createElement("div", { className: "relative flex items-top justify-center min-h-screen bg-gray-100 dark:bg-gray-900 sm:items-center sm:pt-0" },
        react_1.default.createElement(inertia_react_2.Head, { title: "Homepage" }),
        canLogin ? (react_1.default.createElement("div", { className: "hidden fixed top-0 right-0 px-6 py-4 sm:block" }, page.props.user ? (react_1.default.createElement(inertia_react_1.InertiaLink, { href: route("dashboard"), className: "text-sm text-gray-700 underline" }, "Dashboard")) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(inertia_react_1.InertiaLink, { href: route("login"), className: "text-sm text-gray-700 underline" }, "Log in"),
            canRegister ? (react_1.default.createElement(inertia_react_1.InertiaLink, { href: route("register"), className: "ml-4 text-sm text-gray-700 underline" }, "Register")) : null)))) : null));
}
exports.default = Homepage;
